const events = {
  cancelSubscription: {
    eventName: 'cancelSubscriptionInitiate',
    actionType: 'cancel_initiate',
    locationInPage: 'My Subscription',
  },
  benefitsView: {
    view: {
      eventName: 'cancelSubscriptionOverlayFOMO',
      actionType: 'FOMOWidgetViewed',
      navigationElement: 'My Subscription',
    },
    continueCancellation: {
      eventName: 'cancelSubscriptionContinue',
      actionType: 'cancel_continue', //
      navigationElement: 'Cancel Subscription FOMO',
    },
    dismissed: {
      eventName: 'manageSubscription',
      actionType: 'FOMO_dismiss',
      navigationElement: 'Cancel Subscription FOMO',
    },
    keepMySubscription: {
      eventName: 'keepMySubscriptionFOMO',
      actionType: 'keepMySubscription',
      navigationElement: 'Cancel Subscription FOMO',
    },
  },
  offerView: {
    view: {
      eventName: 'cancelSubscriptionOfferOverlay',
      actionType: 'ExclusiveOfferViewed',
      navigationElement: 'Continue Cancellation FOMO',
    },
    confirmCancellation: {
      eventName: 'confirmSubscriptionCancellation',
      actionType: 'cancel_confirm',
      navigationElement: 'Cancel Subscription OfferWidget',
    },
    redeemOffer: {
      eventName: 'redeemExclusiveOffer',
      actionType: 'redeemOffer_cancelInitiate',
      navigationElement: 'Cancel Subscription OfferWidget',
    },
    dismissed: {
      eventName: 'manageSubscription',
      actionType: 'offerWidgetDismiss_exclusiveOffer',
      navigationElement: 'Cancel Subscription OfferWidget',
    },
  },
  cancelComplete: {
    view: {
      eventName: 'subscriptionCancellationComplete',
      actionType: 'cancel_complete',
      navigationElement: 'Continue Cancellation OfferWidget',
    },
    returnToMySubscription: {
      eventName: 'manageSubscription',
      actionType: 'returnMySubscription_confirmationWidget',
      navigationElement: 'Cancellation Confirmation Widget',
    },
    dismissed: {
      eventName: 'manageSubscription',
      actionType: 'cancelConfirmation_dismiss',
      navigationElement: 'Cancellation Confirmation Widget',
    },
  },
  offerConfirmation: {
    view: {
      eventName: 'cancelSubscriptionOverlay',
      actionType: 'discountWidgetViewed',
      navigationElement: 'Redeem Exclusive OfferWidget',
    },
    cancelSubscription: {
      eventName: 'cancelSubscriptionRedeem',
      actionType: 'cancel_afterRedeem',
      navigationElement: 'Cancel Subscription DiscountWidget',
    },
    returnToMySubscription: {
      eventName: 'manageSubscription',
      actionType: 'returnMySubscription_discountWidget',
      navigationElement: 'Cancel Subscription DiscountWidget',
    },
    dismissed: {
      eventName: 'manageSubscription',
      actionType: 'offerWidgetDismiss_discountWidget',
      navigationElement: 'Cancel Subscription DiscountWidget',
    },
  },
  seeOffer: {
    cta: {
      eventName: 'manageSubscription',
      actionType: 'seeOfferCTA',
      navigationElement: 'My Subscription',
    },
    view: {
      eventName: 'cancelSubscriptionOverlay',
      actionType: 'ExclusiveOfferViewed',
      navigationElement: 'My Subscription See Offer',
    },
    returnToMySubscription: {
      eventName: 'manageSubscription',
      actionType: 'returnMySubscription_seeOfferWidget',
      navigationElement: 'Cancel Subscription SeeOfferWidget',
    },
    confirmCancellation: {
      eventName: 'manageSubscription',
      actionType: 'returnMySubscription_seeOfferWidget',
      navigationElement: 'Cancel Subscription SeeOfferWidget',
    },
    redeemOffer: {
      eventName: 'redeemSeeOffer',
      actionType: 'redeemOffer_cancelComplete',
      navigationElement: 'Cancel Subscription SeeOfferWidget',
    },
    dismissed: {
      eventName: 'manageSubscription',
      actionType: 'seeOfferWidget_dismiss',
      navigationElement: 'Cancel Subscription SeeOfferWidget',
    },
  },
};

export default events;
